// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMMENT_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie odpovede";
